import React, { useState } from 'react'

import { Card } from '@plurall/elo-beta'
import { UPDATE_PERSON_NAME } from 'graphql/mutations'
import PropTypes from 'prop-types'

import {
  graphqlClient,
  handleGraphQLErrorsWithToast,
  hasRole,
  isDisableChangePersonalData,
  isNotAllowedToCatchResponsibleEmail,
  ROLE_STUDENT_ID,
} from 'utils'
import { nameValidation } from 'utils/functions'

import { RowWithInput } from './components/Rows'
import styles from './PersonalData.module.css'
import { MESSAGES } from './utils/constants'
import { renderValidationText } from './utils/functions'

const CardPersonalData = ({ data }) => {
  const [nameError, setNameError] = useState(null)
  const [loadingUpdateName, setLoadingUpdateName] = useState(null)
  const [name, setName] = useState(data.name)
  const isStudent = hasRole(data, ROLE_STUDENT_ID)

  const checkName = newName => {
    const error = nameValidation(newName)
    setNameError(error)
    return error
  }

  const updateName = async newName => {
    const noDoubleSpaceName = newName.replace(/\s\s+/g, ' ')
    const error = checkName(noDoubleSpaceName)

    if (!error) {
      try {
        setLoadingUpdateName(true)

        setNameError(null)
        setName(noDoubleSpaceName)
        const {
          data: { updatePerson },
        } = await graphqlClient().mutate({
          mutation: UPDATE_PERSON_NAME,
          variables: { id: Number(data.id), email: data.email, name: noDoubleSpaceName },
        })
        setName(updatePerson.name)
      } catch (error) {
        handleGraphQLErrorsWithToast(
          error,
          'Não foi possível atualizar o nome. Tente novamente mais tarde.',
        )
      } finally {
        setLoadingUpdateName(false)
      }
    }
  }

  const shouldShowCode = () => isStudent && !isNotAllowedToCatchResponsibleEmail(data)

  return (
    <div className={styles.card}>
      <Card title='Dados pessoais' renderHeaderActions={() => {}}>
        <div className={styles['card-content']}>
          <RowWithInput
            name='Nome completo'
            value={name}
            onSave={updateName}
            onChange={checkName}
            dataTestId='input-name'
            disabled={isDisableChangePersonalData({
              byIntegration: data.byIntegration,
              externalReferences: data.externalReference,
            })}
            {...renderValidationText(loadingUpdateName, 'informative', MESSAGES.saving)}
            {...renderValidationText(nameError, 'negative', nameError)}
          />
          {data.cpf && <RowWithInput name='CPF' type='cpf' value={data.cpf} disabled />}
          <RowWithInput name='Plurall Id' value={data.id} disabled />
          {shouldShowCode() && (
            <RowWithInput
              name='Código de Vínculo'
              value={data.publicCode}
              hintText='O código de vínculo é utilizado para o vínculo de responsável.'
              disabled
            />
          )}
        </div>
      </Card>
    </div>
  )
}

CardPersonalData.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    cpf: PropTypes.string,
    publicCode: PropTypes.string,
    email: PropTypes.string,
    byIntegration: PropTypes.bool,
    externalReference: PropTypes.arrayOf(
      PropTypes.shape({
        applicationName: PropTypes.string,
      }),
    ),
  }),
}

export default CardPersonalData
